export const SESSION_TIMEOUT = {
  UPDATE_DELAY: 1000, // Controls the delay between the new countdown on modal
  TIMER: 60 * 5, // Controls the countdown on TimeOut Modal
  GMA_TIMEOUT: 1200
};